<template>
  <HrPageLayout
    title="My Off Days"
    subtitle="My Leave"
    :breadcrumb-items="[
      { label: 'Dashboard', route: '/employee-dashboard' },
      { label: 'My Leave' }
    ]"
  >
    <template #header-actions>
      <router-link to="/employee-off-day-apply" class="hr-btn hr-btn-primary">
        <i class="bx bx-plus-circle"></i> Apply for Off Day
      </router-link>
    </template>

    <div class="row mb-3">
      <div class="col-md-3" v-for="(stat, key) in statCards" :key="key">
        <div class="card">
          <div class="card-body text-center">
            <h6 class="text-muted text-uppercase small">{{ stat.label }}</h6>
            <h3 class="mb-0">{{ statistics[stat.key] || 0 }}</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-3">
            <select v-model="filters.status" class="form-select" @change="loadHistory">
              <option value="">All status</option>
              <option value="Pending">Pending</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>
        </div>

        <div v-if="loading" class="text-center py-4"><div class="spinner-border text-primary"></div></div>
        <div v-else-if="!requests.length" class="text-center text-muted py-4">No off day requests yet.</div>
        <div v-else class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Program</th>
                <th>Dates</th>
                <th>Days</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Approved by</th>
                <th>Applied</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in requests" :key="r.id">
                <td>{{ r.program_name }}</td>
                <td>{{ formatDate(r.start_date) }} – {{ formatDate(r.end_date) }}</td>
                <td>{{ r.total_days }}</td>
                <td>{{ r.reason }}</td>
                <td><span class="badge" :class="badgeClass(r.status)">{{ r.status }}</span></td>
                <td>
                  <template v-if="isApproved(r.status)">
                    {{ r.approved_by || '—' }}
                    <small v-if="r.approval_date" class="d-block text-muted">{{ formatDate(r.approval_date) }}</small>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>{{ formatDate(r.created_at) }}</td>
                <td>
                  <button
                    v-if="isPending(r.status)"
                    class="btn btn-sm btn-outline-danger"
                    @click="cancelRequest(r)"
                  >Cancel</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </HrPageLayout>
</template>

<script>
import HrPageLayout from '@/components/hrActions/HrPageLayout.vue';
import { authUrl, execute } from '@/api';

export default {
  name: 'EmployeeOffDayHistory',
  components: { HrPageLayout },
  data() {
    return {
      loading: false,
      requests: [],
      statistics: {},
      filters: { status: '' },
      statCards: [
        { key: 'total', label: 'Total' },
        { key: 'pending', label: 'Pending' },
        { key: 'approved', label: 'Approved' },
        { key: 'totalDaysApproved', label: 'Days approved' }
      ]
    };
  },
  mounted() {
    this.loadHistory();
  },
  methods: {
    formatDate(d) {
      if (!d) return '—';
      return new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    },
    isPending(s) {
      return String(s).toLowerCase() === 'pending';
    },
    isApproved(s) {
      return String(s).toLowerCase() === 'approved';
    },
    badgeClass(s) {
      const x = String(s).toLowerCase();
      if (x === 'approved') return 'bg-success';
      if (x === 'rejected') return 'bg-danger';
      if (x === 'cancelled') return 'bg-secondary';
      return 'bg-warning text-dark';
    },
    async loadHistory() {
      this.loading = true;
      const data = new FormData();
      data.append('function', 'getEmployeeOffDayHistory');
      data.append('status', this.filters.status);
      try {
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.requests = res.data.data?.requests || [];
          this.statistics = res.data.data?.statistics || {};
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async cancelRequest(r) {
      if (!confirm('Cancel this off day request?')) return;
      const data = new FormData();
      data.append('function', 'cancelOffDayRequest');
      data.append('requestId', r.id);
      const res = await execute(data, authUrl);
      if (res.data.success) this.loadHistory();
      else alert(res.data.message || 'Cancel failed');
    }
  }
};
</script>

